<template>
    <div class="row">
        <div class="col-md-12 mg-t-10">
            <div class="card ht-100p">
                <div class="card-header d-flex align-items-center justify-content-between">
                    <h6 class="mg-b-0">Officer Profile</h6>
                    <div class="d-flex tx-18">
                        <a href="" class="link-03 lh-0"><i class="icon ion-md-refresh"></i></a>
                        <a href="" class="link-03 lh-0 mg-l-10"><i class="icon ion-md-more"></i></a>
                    </div>
                </div>
                <p v-if="officer.officerLoading" align="center" class="mt-3"><bar-loader  class="custom-class" color="#6d0606" loading="loading" :size="150" sizeUnit="px"></bar-loader></p>
                <p v-else-if="model == null" class="no-config mt-3">No officer record for you found on this account. <br>
                </p>
                <b-form v-else class="p-4" >
                    <b-row v-if="model != null" form>
                        <b-col md="4">
                            <image-upload-card
                                :url="model.officerPassportURL"
                                :bvn="model.officerBVN"
                                :name="'passport'"
                                :officer-i-d="model.officerID"
                            ></image-upload-card>
                        </b-col>
                        <b-col md="4">
                            <image-upload-card
                                    :url="model.officerSignatureURL"
                                    :bvn="model.officerBVN"
                                    :name="'signatre'"
                                    :officer-i-d="model.officerID"
                            ></image-upload-card>
                        </b-col>
                        <b-col md="4"></b-col>
                        <b-col md="12">
                            <h5>BIO-DATA</h5>
                        </b-col>
                        <b-col md="3">
                            <b-form-group>
                                <Label for="officerLastName">Surname</Label>
                                <b-form-input required readonly v-model="model.officerLastName" type="text" name="bvn" id="officerLastName"
                                              placeholder="officerLastName here..."/>
                            </b-form-group>
                        </b-col>
                        <b-col md="3">
                            <b-form-group>
                                <Label for="officerFirstName">First Name</Label>
                                <b-form-input required readonly v-model="model.officerFirstName" type="text" name="officerFirstName" id="officerFirstName"
                                              placeholder="officerFirstName here..."/>
                            </b-form-group>
                        </b-col>
                        <b-col md="3">
                            <b-form-group>
                                <Label for="officerMiddleName">Middle Name</Label>
                                <b-form-input required readonly v-model="model.officerMiddleName"  type="text" name="officerMiddleName" id="officerMiddleName"
                                              placeholder="officerMiddleName here..."/>
                            </b-form-group>
                        </b-col>
                        <b-col md="3">
                            <b-form-group>
                                <Label for="passwordConfirmation">Mother's Maiden Name</Label>
                                <b-form-input required readonly v-model="model.officerMaidenName"  type="text" name="officerMaidenName" id="officerMaidenName"
                                              placeholder="Retype Passord here..."/>
                            </b-form-group>
                        </b-col>

                        <b-col md="3">
                            <b-form-group>
                                <Label for="officerGender">Gender</Label>
                                <b-form-input required readonly v-model="model.officerGender" type="text" name="bvn" id="officerGender"
                                              placeholder="officerGender here..."/>
                            </b-form-group>
                        </b-col>
                        <b-col md="3">
                            <b-form-group>
                                <Label for="officerNationality">Nationality</Label>
                                <b-form-input required readonly v-model="model.officerNationality" type="text" name="officerNationality" id="officerNationality"
                                              placeholder="officerNationality here..."/>
                            </b-form-group>
                        </b-col>
                        <b-col md="3">
                            <b-form-group>
                                <Label for="officerDOB">Date of Birth</Label>
                                <b-form-input required readonly v-model="model.officerDOB"  type="text" name="officerDOB" id="officerDOB"
                                              placeholder="officerDOB here..."/>
                            </b-form-group>
                        </b-col>
                        <b-col md="3">
                            <b-form-group>
                                <Label for="officerDesignation">Designation</Label>
                                <b-form-input required readonly v-model="model.officerDesignation"  type="text" name="officerDesignation" id="officerDesignation"
                                              placeholder="officerDesignation Passord here..."/>
                            </b-form-group>
                        </b-col>


                        <b-col md="12">
                            <h5>CONTACT</h5>
                        </b-col>
                        <b-col md="3">
                            <b-form-group>
                                <Label for="officerCountry">Country</Label>
                                <b-form-input required readonly v-model="model.officerCountry" type="text" name="bvn" id="officerCountry"
                                              placeholder="officerCountry here..."/>
                            </b-form-group>
                        </b-col>
                        <b-col md="3">
                            <b-form-group>
                                <Label for="officerState">State</Label>
                                <b-form-input required readonly v-model="model.officerState" type="text" name="officerState" id="officerState"
                                              placeholder="officerState here..."/>
                            </b-form-group>
                        </b-col>
                        <b-col md="3">
                            <b-form-group>
                                <Label for="officerCity">City</Label>
                                <b-form-input required readonly v-model="model.officerCity"  type="text" name="officerCity" id="officerCity"
                                              placeholder="officerCity here..."/>
                            </b-form-group>
                        </b-col>
                        <b-col md="3">
                            <b-form-group>
                                <Label for="officerStreet">Street</Label>
                                <b-form-input required readonly v-model="model.officerStreet"  type="text" name="officerStreet" id="officerStreet"
                                              placeholder="officerStreet here..."/>
                            </b-form-group>
                        </b-col>
                        <b-col md="6">
                            <b-form-group>
                                <Label for="officerPhone">Phone Number</Label>
                                <b-form-input required readonly v-model="model.officerPhone"  type="text" name="officerPhone" id="officerPhone"
                                              placeholder="officerPhone here..."/>
                            </b-form-group>
                        </b-col>
                        <b-col md="6">
                            <b-form-group>
                                <Label for="officerEmail">Email</Label>
                                <b-form-input required readonly v-model="model.officerEmail"  type="text" name="officerEmail" id="officerEmail"
                                              placeholder="officerEmail here..."/>
                            </b-form-group>
                        </b-col>



                        <b-col md="12">
                            <h5>IDENTIFICATION</h5>
                        </b-col>
                        <b-col md="3">
                            <b-form-group>
                                <Label for="officerIDType">ID Type</Label>
                                <b-form-input required readonly v-model="model.officerIDType" type="text" name="bvn" id="officerIDType"
                                              placeholder="officerIDType here..."/>
                            </b-form-group>
                        </b-col>
                        <b-col md="3">
                            <b-form-group>
                                <Label for="officerIDNumber">ID Number</Label>
                                <b-form-input required readonly v-model="model.officerIDNumber" type="text" name="officerIDNumber" id="officerIDNumber"
                                              placeholder="officerIDNumber here..."/>
                            </b-form-group>
                        </b-col>
                        <b-col md="3">
                            <b-form-group>
                                <Label for="officerIDIssueDate">ID Issue Date</Label>
                                <b-form-input required readonly v-model="model.officerIDIssueDate"  type="text" name="officerIDIssueDate" id="officerIDIssueDate"
                                              placeholder="officerIDIssueDate here..."/>
                            </b-form-group>
                        </b-col>
                        <b-col md="3">
                            <b-form-group>
                                <Label for="officerIDExpiryDate">ID Expiry Date</Label>
                                <b-form-input required readonly v-model="model.officerIDExpiryDate"  type="text" name="officerIDExpiryDate" id="officerIDExpiryDate"
                                              placeholder="officerIDExpiryDate here..."/>
                            </b-form-group>
                        </b-col>
                        <b-col md="12">
                            <b-form-group>
                                <Label for="officerBVN">BVN Number</Label>
                                <b-form-input required readonly v-model="model.officerBVN"  type="text" name="officerBVN" id="officerBVN"
                                              placeholder="officerBVN here..."/>
                            </b-form-group>
                        </b-col>



                        <b-col md="12">
                            <h5>EMPLOYER</h5>
                        </b-col>
                        <b-col md="3">
                            <b-form-group>
                                <Label for="officerEmpCompanyName">Company Name</Label>
                                <b-form-input required readonly v-model="model.officerEmpName" type="text" name="bvn" id="officerEmpCompanyName"
                                              placeholder="officerEmpCompanyName here..."/>
                            </b-form-group>
                        </b-col>
                        <b-col md="3">
                            <b-form-group>
                                <Label for="officerEmpOccupation">Occupation</Label>
                                <b-form-input required readonly v-model="model.officerOccupation" type="text" name="officerEmpOccupation" id="officerEmpOccupation"
                                              placeholder="officerEmpOccupation here..."/>
                            </b-form-group>
                        </b-col>
                        <b-col md="3">
                            <b-form-group>
                                <Label for="officerEmpPhone">Employer's Phone</Label>
                                <b-form-input required readonly v-model="model.officerEmpPhone"  type="text" name="officerEmpPhone" id="officerEmpPhone"
                                              placeholder="officerEmpPhone here..."/>
                            </b-form-group>
                        </b-col>
                        <b-col md="3">
                            <b-form-group>
                                <Label for="officerEmpIndustry">Employer's Industry</Label>
                                <b-form-input required readonly v-model="model.officerIndustry"  type="text" name="officerEmpIndustry" id="officerEmpIndustry"
                                              placeholder="officerEmpIndustry here..."/>
                            </b-form-group>
                        </b-col>
                        <b-col md="12">
                            <b-form-group>
                                <Label for="officerEmpAddress">Address</Label>
                                <b-form-input required readonly v-model="model.officerEmpAddress"  type="text" name="officerEmpAddress" id="officerEmpAddress"
                                              placeholder="officerEmpAddress here..."/>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <div class="mt-4 d-flex align-items-right">
                        <!-- <h5 class="mb-0">
                            Already have an account?
                            <router-link to="/" class="text-primary">Sign in</router-link>
                        </h5> -->
                        <div class="ml-auto">
                            <b-button @click="$router.go(-1)" class="btn-wide btn-danger btn-pill btn-shadow btn-hover-shine" size="lg">Back</b-button>
                        </div>
                        <span v-if="company.company[0].roleType === 'ADMIN'">
<!--                            <div v-if="model.officerAuthBank === 'YES'" class="mr" style="margin-right:-80%;">-->
<!--                                <b-button disabled class="btn-wide btn-success btn-pill btn-shadow btn-hover-shine" size="lg">Verified</b-button>-->
<!--                            </div>-->
<!--                            <div v-else class="mr" style="margin-right:-80%;">-->
<!--                                <b-button @click="verifyOfficer()" class="btn-wide btn-info btn-pill btn-shadow btn-hover-shine" size="lg">Verify</b-button>-->
<!--                            </div>-->
                        </span>
                    </div>
                </b-form>
            </div><!-- card -->
        </div>
    </div><!-- row -->
</template>

<script>
    // import FlotChart from "../FlotChart";
    import ImageUploadCard from "../card/ImageUploadCard";
    import {mapState} from 'vuex'
    export default {
        name: "TopCards",
        components:{
            ImageUploadCard
        },
        data(){
            return {

            };
        },
        methods: {
            showAlert(title, message) {
                const options = {title: title, size: 'sm'}
                this.$dialogs.alert(message, options)
                    .then(res => {
                        //console.log(res) // {ok: true|false|undefined}
                    })
            },
            async readOfficersAdmin(){
                await this.$store.dispatch("officer/updateOfficersAdmin", {
                    accID: localStorage.suAccID,
                    requestType: 'officer'
                }, {root: true})
                this.model = this.officerFiltered(localStorage.suOfficerID)[0]
            },

            async verifyOfficer(){
                await this.$store.dispatch("officer/verifyOfficersAdmin", {
                    officerID: localStorage.suOfficerID,
                    requestType: 'officer'
                }, {root: true})
                await this.$store.dispatch("officer/updateOfficersAdmin", {
                    accID: localStorage.suAccID,
                    requestType: 'officer'
                }, {root: true})
                this.model = this.officerFiltered(localStorage.suOfficerID)[0]
            },

            officerFiltered(_item) {
                return this.officer.officers.filter(function (el) {
                    return el.officerID == _item;
                });
            },

            officerFilteredByUserId(_item) {
                return this.officer.officers.filter(function (el) {
                    return el.officerUserID == _item;
                });
            },
        },
        computed:{
            ...mapState([
                'system',
                'company',
                'cbank',
                'officer'
            ]),
            model:{
                get(){
                    //console.log(this.officerFilteredByUserId(this.system.userInfo.id)[0]);
                    return this.officerFilteredByUserId(this.system.userInfo.id)[0];
                },
                set(){

                }
            }
        }
    }
</script>

<style scoped>
    @media only screen and (min-width: 900px) {
        .top-card {
            width: 103%;
        }
    }
    @media only screen and (min-width: 707px) and (max-width: 900px) {
        .top-card {
            width: 104%;
        }
    }

    @media only screen and (min-width: 517px)  and (max-width: 707px) {
        .top-card {
            width: 105%;
        }
    }

    @media only screen and (min-width: 451px)  and (max-width: 517px) {
        .top-card {
            width: 106%;
        }
    }

    @media only screen  and (max-width: 451px) {
        .top-card {
            width: 107%;
        }
    }
    .h-100 {
        height: 100vh !important;
    }
    @media only screen and  (max-width: 991px) {
        .extra{
            display: none;
        }
    }
    .image-input{
        display: block;
        width: 100%;
        height: 300px;
        cursor: pointer;
        background-size: cover;
        background-position: center center;
    }

    .placeholder{
        background: #F0F0F0;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #333;
        font-size: 18px;
        font-family: Helvetica,serif;
    }

    .placeholder:hover{
        background: #E0E0E0
    }

    .file-input{
        display: none;
    }
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>